import { injectable, inject } from 'inversify'

import { RoutingService } from '#AltServices'

@injectable()
export class AuthRoutingService {
  constructor(
    @inject(RoutingService) readonly router: RoutingService,
  ) {}
}
